import React, { useState, useEffect } from "react";
import { RxCross2 } from "react-icons/rx";

function AictePopup() {
  const [showPopup, setShowPopup] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowPopup(true);
    }, 1000); // 1 second

    return () => clearTimeout(timer);
  }, []);

  if (!showPopup) return null;

  return (
    <div className="PopupOverlay">
      <div className="PopupContent" data-aos="zoom-in">
        <div className="PopupClose" onClick={() => setShowPopup(false)}>
          <RxCross2 size={24} />
        </div>
        <div className="PopupHeader">
          <img src="/Images/vbu_logo.png" alt="VBU Logo" className="PopupLogo" />
          <h3>University Department of Computer Applications</h3>
        </div>
        <div className="PopupBody">
          <div className="AicteTag">AICTE Approved</div>
          <p className="IntakeInfo">Intake: <strong>60</strong></p>
          <p className="IntakeInfo">Permanent Id : <strong>1-3354179681</strong></p>
          <a 
            href="https://aicte.gov.in/" 
            target="_blank" 
            rel="noreferrer" 
            className="PopupLink"
          >
            Click Here To Visit AICTE Website
          </a>
        </div>
      </div>
    </div>
  );
}

export default AictePopup;
